import {
    validateDateOfBirth,
    validateEmailAdress,
    validateInputLength,
    validateInputNumber,
    validateInputString,
    validatePhoneNumber,
    validateRadio,
} from 'validation/validation';
import { FIELD_LENGTH } from '../../../../../../../constants';

export const errorModel = (data: any) => ({
    firstName: validateInputString(data?.firstName),
    lastName: validateInputString(data?.lastName),
    dateOfBirth: validateDateOfBirth(data?.dateOfBirth),
    gender: validateRadio(data?.gender),
    street: validateInputString(data?.street) || validateInputLength(data?.street, FIELD_LENGTH.street),
    ORT: validateInputString(data?.ORT) || validateInputLength(data?.ORT, FIELD_LENGTH.city),
    countryOfNationality: validateInputNumber(data?.countryOfNationality),
    countryOfResidence: validateInputNumber(data?.countryOfResidence),
    primaryEmail: validateEmailAdress(data?.primaryEmail),
    primaryPhoneNumber: validatePhoneNumber(data?.primaryPhoneNumber, false),
});
